import { Button, GLOBAL_SHORTCUTS, Modal, ModalBody, ModalFooter, ModalHeader } from '@deephaven/components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoPastePermissionModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    errorMessage = _ref.errorMessage;
  var pasteShortcutText = GLOBAL_SHORTCUTS.PASTE.getDisplayText();
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    toggle: onClose,
    centered: true,
    children: [/*#__PURE__*/_jsx(ModalHeader, {
      closeButton: false,
      children: "No Paste Permission"
    }), /*#__PURE__*/_jsxs(ModalBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: errorMessage
      }), /*#__PURE__*/_jsxs("p", {
        children: ["You can still use ", pasteShortcutText, " to paste."]
      })]
    }), /*#__PURE__*/_jsx(ModalFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        kind: "primary",
        onClick: onClose,
        children: "Dismiss"
      })
    })]
  });
}
//# sourceMappingURL=NoPastePermissionModal.js.map